export const coockieAge = 30 * 24 * 60 * 60;

export const firebaseCookieName = 'NextFirebase';

export const translationCoockieName = 'translation';
